import React from "react"
import FilterPanel from "../../../components/panels/FilterPanel";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import gql from "graphql-tag";
import {Query} from "react-apollo";
import {fromJS, Map} from "immutable";

const SkuFilterPanel = (props) => {

  return (
    <Query query={SKUS}>
      {({ loading, error, data }) => {
        if (loading) return <Loading />
        if (error) return <GraphQLErrors error={error} />
        let skus = fromJS(data.waterPalletSkus).map((x) => Map({id: x.get("sku"), title: x.get("sku")}));
        skus = skus.unshift(Map({id: "", title: "Any"}));

        return (
          <FilterPanel
            expanded={true}
            title={props.title}
            onClick={(item) => props.onClick(item.get("id"))}
            options={skus}
            filter={props.filter}
            valueKey="id"
            labelKey="title"
            />          
        )
      }}
    </Query>
  )
}

const SKUS = gql`
  query waterPalletSkus {
    waterPalletSkus {
      sku
    }
  }
`;


export default SkuFilterPanel;